import { Box, LinearProgress } from '@mui/material';
import React from 'react';
export function TableLoadingBar() {
    return (React.createElement(Box, { sx: { position: 'absolute', left: 0, top: 0, right: 0 } },
        React.createElement(LinearProgress, null)));
}
